import { buildLabel } from './labelBuilder';

export const groupOrdersByFamily = (orders) => {
  const grouped = {};
  
  Object.entries(orders).forEach(([key, quantity]) => {
    const family = key.split(':')[0];
    if (!grouped[family]) {
      grouped[family] = [];
    }
    grouped[family].push([key, quantity]);
  });

  // Sort each family's items by label
  Object.keys(grouped).forEach(family => {
    grouped[family].sort(([keyA], [keyB]) => {
      const labelA = buildLabel(keyA);
      const labelB = buildLabel(keyB);
      return labelA.localeCompare(labelB);
    });
  });

  return grouped;
};

export const groupPresetsByFamily = (presets) => {
  const grouped = {};
  
  presets.forEach(preset => {
    const family = preset.key.split(':')[0];
    if (!grouped[family]) {
      grouped[family] = [];
    }
    grouped[family].push(preset);
  });

  // Sort each family's presets by label
  Object.keys(grouped).forEach(family => {
    grouped[family].sort((a, b) => {
      const labelA = buildLabel(a.key);
      const labelB = buildLabel(b.key);
      return labelA.localeCompare(labelB);
    });
  });

  return grouped;
};